export default function reducer(
  state = {
    fetching: false,
    fetched: false,
    visible: {
      gps: true,
      compass: true
    },
    anemometer: {
      showSpeed: false,
      showDirection: true,
      direction: 0,
      speed: 0
    },
    barometer: {
      hpa: 1012
    },
    compass: {
      heading: 0
    },
    gps: {
      title: 'Satellite #4',
      datetime: '2019-09-10 12:42',
      lng: `31\u00B0 14.74334'N`,
      lat: `121\u00B0 23.742234'E`,
      sog :'10.3kt',
      cog: `10.0\u00B0`
    },
  },
  action,
) {

  // Set payload specifics
  switch (action.type) {
    case 'SET_COMPASS_FULFILLED': {
      return {
        ...state,
        compass: action.payload
      };
    }
    case 'SET_ANEMOMETER_FULFILLED': {
      return {
        ...state,
        anemometer: action.payload
      };
    }
    case 'SET_BAROMETER_FULFILLED': {
      return {
        ...state,
        barometer: action.payload
      };
    }
    case 'SET_GPS_FULFILLED': {
      return {
        ...state,
        gps: action.payload
      };
    }
    default:
      break;
  }
  return state;
}
